import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class ResultMailService {
  private apiUrl = '/spring/resultmails';

  constructor(
    private http: HttpService) { }

  get(ownerId?: number): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}/${ownerId}`;
    return this.http.get(url);
  }

  put(
    ownerId: number,
    reportCd: string,
    mailfromTx: string,
    mailtoTx: string,
    mailccTx: string,
    mailsubjectTx: string,
    mailbodyTx: string,
    fileTx: string,
    sendTm: string,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}/${ownerId}/${reportCd}`;
    const jsonInput = {
      mailfromTx: mailfromTx,
      mailtoTx: mailtoTx,
      mailccTx: mailccTx,
      mailsubjectTx: mailsubjectTx,
      mailbodyTx: mailbodyTx,
      fileTx: fileTx,
      sendTm: sendTm,
      updprogramCd: updprogramCd
    };

    return this.http.put(url, jsonInput);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/result-mail/result-mail.service.ts